import { QueryKey, queryOptions, useQuery, UseQueryOptions, useInfiniteQuery } from '@tanstack/react-query'

import { HttpError } from '@/api/http'
import { getNextPageParamHelper } from '../utils'
import { getChargingStatus, getChargingHistory, getChargingConfig } from './services'
import {
  GetChargingStatusPayload,
  GetChargingStatusResponse,
  GetChargingHistoryResponse,
  GetChargingConfigResponse,
} from './types'

export const createChargingHistoryQueryOptions = () =>
  queryOptions({
    queryKey: ['charging-history'],
    queryFn: () => getChargingHistory(),
  })

export const useQueryChargingConfig = (
  options?: Omit<UseQueryOptions<GetChargingConfigResponse, HttpError>, 'queryKey' | 'queryFn'>
) => {
  const queryKey: QueryKey = ['charging-config']
  const queryFn = () => getChargingConfig()

  return useQuery({
    queryKey,
    queryFn,
    ...options,
  })
}

export const useQueryChargingStatus = (
  params: GetChargingStatusPayload,
  options?: Omit<UseQueryOptions<GetChargingStatusResponse, HttpError>, 'queryKey' | 'queryFn'>
) => {
  const queryKey: QueryKey = ['charging-status', params]
  const queryFn = () => getChargingStatus(params)

  return useQuery({
    queryKey,
    queryFn,
    ...options,
  })
}

export const useQueryChargingHistory = (
  options?: Omit<UseQueryOptions<GetChargingHistoryResponse, HttpError>, 'queryKey' | 'queryFn'>
) => {
  const queryKey: QueryKey = ['charging-history']
  const queryFn = () => getChargingHistory()

  return useQuery({
    queryKey,
    queryFn,
    ...options,
  })
}

export const useInfiniteQueryChargingHistory = () => {
  return useInfiniteQuery({
    queryKey: ['charging-history-infinite'],
    queryFn: ({ pageParam = 1 }) => getChargingHistory({ page: pageParam }),
    initialPageParam: 1,
    getNextPageParam: getNextPageParamHelper,
  })
}
